import { useEffect } from 'react'

import useAppDispatch from '../../../store/hooks/useAppDispatch'
import localStorageUtils from '../../app/utils/localStorageUtils'
import { validatePreOrderCheckout } from '../../preOrder/store/preOrderThunks'
import { validateCheckout } from '../store/checkoutThunks'
import { LocalStorageCartMeta } from '../types'

/** Restores the stored cart, if any, once when the app loads */
export default function useInitialCheckoutValidation() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const checkout = localStorageUtils.getItem<LocalStorageCartMeta>('cartMeta')

    if (checkout) {
      if (checkout.isPreOrderCheckout) {
        dispatch(validatePreOrderCheckout({}))
      } else {
        dispatch(validateCheckout({}))
      }
    }
  }, [dispatch])
}
